import React from "react";
import FunctionHeader from "../../components/Header/FunctionHeader";
import Spinner from "presentation/components/Shared/Spinner";
import usePermissionCheck from "presentation/hooks/use-check-permissions";
import ClientGrid from "presentation/components/Client/ClientGrid";

const ClientGridPage = ({ children }: { children?: React.ReactNode }) => {
  const { isLoading } = usePermissionCheck({ requiredFunction: "clients" });

  if (isLoading) {
    return <Spinner />;
  }
  return (
    <div>
      <FunctionHeader title="Clientes" />
      <ClientGrid />
    </div>
  );
};

export default ClientGridPage;
